export default __webpack_public_path__ + "static/figure1-bfa80492158c4f9849419c0fcb378fff.webp";